import * as ActionTypes from '../action-types';

const initialState = {
  productIdToAddToWaitlist: null
};

const AddToCart = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.ADD_PRODUCT_TO_WAITLIST:
      return { ...state, productIdToAddToWaitlist: action.productId };
    default:
      return state;
  }
};

export default AddToCart;
